export enum Condition {
  In = 'IN',
  NotIn = 'NOTIN',
  Contains = 'Contains',
  BeginsWith = 'BeginsWith',
  EndsWith = 'EndsWith',
}
